var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50065 15.8335V3.3335",
    stroke: "#808CB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 11.6665V17.4134",
    stroke: "#808CB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.8335V15.2769C17.5008 15.6351 17.2719 15.9535 16.9321 16.0668C15.851 16.4273 13.5355 17.1992 12.7595 17.458C12.5897 17.5146 12.4059 17.5142 12.2363 17.4567L7.76355 15.9656C7.59248 15.9085 7.40752 15.9085 7.23645 15.9656L3.59688 17.1789C3.34276 17.2636 3.0634 17.221 2.84609 17.0644C2.62877 16.9078 2.5 16.6562 2.5 16.3884V5.51079C2.5 5.15211 2.72951 4.83367 3.06978 4.72024L6.97289 3.41904C7.31503 3.30498 7.68492 3.30498 8.02706 3.41904L9.16667 3.79893",
    stroke: "#808CB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 5.4165C11.666 6.78193 13.156 8.24051 14.006 8.9618C14.3417 9.23473 14.8228 9.23473 15.1585 8.9618C16.0093 8.24051 17.4993 6.78193 17.4993 5.4165",
    stroke: "#808CB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5835 5.20834C14.6985 5.2088 14.7913 5.30228 14.791 5.41723C14.7907 5.53218 14.6974 5.62516 14.5824 5.625C14.4675 5.62485 14.3744 5.53162 14.3744 5.41667C14.3741 5.36118 14.396 5.3079 14.4353 5.26874C14.4747 5.22958 14.528 5.20782 14.5835 5.20834",
    stroke: "#808CB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 5.41667V5.41667C11.666 3.80584 12.9719 2.5 14.5827 2.5V2.5C16.1935 2.5 17.4993 3.80584 17.4993 5.41667V5.41667",
    stroke: "#808CB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/addressIcon.8fc583be48d4c818118373504b4230a5.svg";
export { ForwardRef as ReactComponent };